import styled from "styled-components";
import {Slider} from "antd";

export const SliderField = styled(Slider)`
    .ant-slider-track {
        background-color: unset !important;
    }
`;

export const InputField = styled.input`
    display: none;
`;
